import { Box, Typography, theme } from '@sbv-clients/ui-shared';

import { useDeparturesGet } from '../../../../services/dashboard';
import useUnscheduledReportModal from '../unscheduled-modal';
import DeparturesTable from './departures-table';

interface DeparturesProps {
  departmentId: number;
  positionId: number;
  startDate: Date;
}

const Departures = ({
  departmentId,
  positionId,
  startDate,
}: DeparturesProps) => {
  const { data, isLoading } = useDeparturesGet(
    departmentId,
    positionId,
    startDate
  );
  const {
    departuresResponse: departures = [] || [],
    unscheduledDepartures = [] || [],
  } = data || {};
  const { modal, openModal } = useUnscheduledReportModal();
  return (
    <Box width="100%">
      <Typography variant="subtitle1" my={3} color={theme.text.sectionSubtitle}>
        Departures
      </Typography>
      <DeparturesTable
        data={departures}
        unScheduledDepartures={unscheduledDepartures}
        openModal={openModal}
        isLoading={isLoading}
      />
      {modal}
    </Box>
  );
};

export default Departures;
